var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/home_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67943 4.38462C6.2424 4.38462 5.84285 4.63154 5.64743 5.02245L4.81248 6.69231H19.1875L18.3526 5.02245C18.1572 4.63154 17.7576 4.38462 17.3206 4.38462H6.67943ZM19.6154 8.07692H4.38462V18.4615C4.38462 19.0988 4.90121 19.6154 5.53846 19.6154H18.4615C19.0988 19.6154 19.6154 19.0988 19.6154 18.4615V8.07692ZM4.40898 4.40322C4.83897 3.54324 5.71795 3 6.67943 3H17.3206C18.282 3 19.161 3.54324 19.591 4.40323L20.9269 7.07502C20.975 7.17115 21 7.27712 21 7.38462V18.4615C21 19.8635 19.8635 21 18.4615 21H5.53846C4.13651 21 3 19.8635 3 18.4615V7.38462C3 7.27712 3.02502 7.17115 3.07309 7.07502L4.40898 4.40322Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.6923C9 16.31 9.30997 16 9.69231 16H14.3077C14.69 16 15 16.31 15 16.6923C15 17.0746 14.69 17.3846 14.3077 17.3846H9.69231C9.30997 17.3846 9 17.0746 9 16.6923Z",
    fill: "#92929D",
    stroke: "#92929D",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.cc923059110e153206179d0200704487.svg";
export { ForwardRef as ReactComponent };